export const THEMES = [
  { id: "premium-dark", name: "Premium Dark", values: { bg: "#071516", panel: "rgba(9,24,26,.62)", panelStrong: "rgba(12,31,35,.9)", text: "#f7fffd", muted: "#98aba9", border: "rgba(255,255,255,.14)", shadow: "0 24px 80px rgba(0,0,0,.45)" } },
  { id: "glass-pro", name: "Glass Pro", values: { bg: "#061014", panel: "rgba(255,255,255,.09)", panelStrong: "rgba(255,255,255,.15)", text: "#f8fbff", muted: "#a5b6bd", border: "rgba(255,255,255,.2)", shadow: "0 30px 90px rgba(0,0,0,.5)" } },
  { id: "clean-light", name: "Clean Light", values: { bg: "#f5f8f8", panel: "rgba(255,255,255,.74)", panelStrong: "#ffffff", text: "#0c1618", muted: "#607073", border: "rgba(0,0,0,.1)", shadow: "0 20px 70px rgba(15,50,55,.14)" } },
  { id: "neon-ai", name: "Neon AI", values: { bg: "#080912", panel: "rgba(13,18,34,.7)", panelStrong: "#11162b", text: "#f7f6ff", muted: "#aaa9c4", border: "rgba(146,116,255,.25)", shadow: "0 24px 80px rgba(0,0,0,.5)" } },
  { id: "minimal-pro", name: "Minimal Pro", values: { bg: "#111514", panel: "rgba(26,31,30,.65)", panelStrong: "#202625", text: "#f3f5f2", muted: "#a8afab", border: "rgba(255,255,255,.12)", shadow: "0 22px 70px rgba(0,0,0,.36)" } },
  { id: "product-studio", name: "Product Studio", values: { bg: "#111315", panel: "rgba(28,30,33,.66)", panelStrong: "#202326", text: "#fbfbf8", muted: "#aeb2b0", border: "rgba(255,255,255,.13)", shadow: "0 22px 80px rgba(0,0,0,.38)" } },
  { id: "social-creator", name: "Social Creator", values: { bg: "#111017", panel: "rgba(29,25,38,.68)", panelStrong: "#241f30", text: "#fff9ff", muted: "#b7aebd", border: "rgba(255,255,255,.14)", shadow: "0 24px 78px rgba(0,0,0,.42)" } },
  { id: "midnight-gold", name: "Midnight Gold", values: { bg: "#0d1014", panel: "rgba(24,24,27,.7)", panelStrong: "#1a1a1e", text: "#fffaf0", muted: "#b9b0a1", border: "rgba(244,201,93,.22)", shadow: "0 28px 90px rgba(0,0,0,.5)" } }
];

export const ACCENTS = {
  Blue: "#4da3ff",
  Teal: "#42f6d7",
  Purple: "#a78bfa",
  Gold: "#f4c95d",
  Pink: "#ff7ac8",
  Red: "#ff6b6b",
  Green: "#70e087",
  Silver: "#d7dee8"
};

export function applyTheme(themeId = "premium-dark", accentName = "Teal", motion = "full") {
  const theme = THEMES.find((item) => item.id === themeId) || THEMES[0];
  const root = document.documentElement;
  const accent = ACCENTS[accentName] || ACCENTS.Teal;
  root.style.setProperty("--bg", theme.values.bg);
  root.style.setProperty("--panel", theme.values.panel);
  root.style.setProperty("--panel-strong", theme.values.panelStrong);
  root.style.setProperty("--text", theme.values.text);
  root.style.setProperty("--muted", theme.values.muted);
  root.style.setProperty("--accent", accent);
  root.style.setProperty("--accent-2", accentName === "Gold" ? "#42f6d7" : "#f4c95d");
  root.style.setProperty("--border", theme.values.border);
  root.style.setProperty("--shadow", theme.values.shadow);
  root.style.setProperty("--danger", "#ff6b6b");
  root.style.setProperty("--success", "#70e087");
  root.style.setProperty("--warning", "#f4c95d");
  root.style.setProperty("--motion-scale", motion === "none" ? "0" : motion === "reduced" ? ".45" : "1");
  document.querySelector("meta[name='theme-color']")?.setAttribute("content", theme.values.bg);
}
